import { updateSurveyMutation, fetchIsSurveyCompletedQuery } from "../../api/graphql/queries/survey";
import { updateActionErrors } from "./updateErrors";
import { FETCH_SURVEY_STATUS, UPDATE_SURVEY } from "../actions/actionTypes";
import graphqlClient from "../../api/axios_interceptor";

const fetchSurveyStatusMiddleware = async (action) => {
    try {
        const queryResult = await graphqlClient({
            data: {
                query: fetchIsSurveyCompletedQuery(),
            },
        });
        if (queryResult.data.errors) {
            console.error('GraphQL Errors:', queryResult.data.errors);
            return updateActionErrors(action, queryResult.data.errors);
        } else {
            const isSurveyCompleted = queryResult.data.data.isSurveyCompleted;
            const surveyQuestions = queryResult.data.data.surveyQuestions;
            return {
                ...action,
                payload: {
                    ...action.payload,
                    isSurveyCompleted,
                    surveyQuestions
                },
            };
        }
    } catch (error) {
        console.error(error);
        return updateActionErrors(action);
    }
};

const updateSurveyMiddleware = async (action) => {
    try {
        const queryResult = await graphqlClient({
            data: {
                query: updateSurveyMutation(action.payload),
            },
        });

        if (queryResult.data.errors) {
            console.error('GraphQL Errors:', queryResult.data.errors);
            return updateActionErrors(action, queryResult.data.errors);
        } else if (queryResult.data.data.updateSurvey.errors) {
            return updateActionErrors(action, queryResult.data.data.updateSurvey.errors);
        } else {
            return {
                ...action,
                payload: {
                    ...action.payload,
                    isSurveyCompleted: queryResult.data.data.updateSurvey.isSurveyCompleted      
                },
            };
        }
    } catch (error) {
        console.error(error);
        return updateActionErrors(action);
    }
};

export const surveyMiddleware = storeAPI => next => async action => {
    switch (action.type) {
        case FETCH_SURVEY_STATUS:
            action = await fetchSurveyStatusMiddleware(action);
            break;
        case UPDATE_SURVEY:
            action = await updateSurveyMiddleware(action);
            break;
    }
    return next(action);
};
